import { getFormIdField, getSectionStudents } from './index';

/**
 * Gets the section name for classes dropdown in assign/manage modal.
 * @param {object} - The data needed to check for section's name to be displayed.
 * @returns {string} - The section's name to be displayed in the form.
 * */
const getSectionName = ({
  isFinalExam,
  individualStudentAssignmentFlag,
  section,
  isAssign,
  studentsFormData,
  subjectClassList,
  disabledStudentIds,
}) => {
  const { id: formId, name, assignmentId } = section;
  let sectionName = name;
  const sectionId = section.sectionId.toString();

  if (!isFinalExam && individualStudentAssignmentFlag) {
    const currentSectionFormStudentsLength = (studentsFormData || []).filter(
      (student) => {
        const customFormFieldId = getFormIdField(student.studentId, formId);

        return (
          student.id === customFormFieldId &&
          (isAssign
            ? !disabledStudentIds.includes(student.id)
            : !student.fromOtherISA)
        );
      },
    ).length;
    const currentSectionAllStudents = getSectionStudents(
      subjectClassList,
      sectionId,
    );
    const currentSectionAllStudentsLength = currentSectionAllStudents.length;
    const currentSectionAvailableStudents = isAssign
      ? currentSectionAllStudents.filter(
          (currentStudent) =>
            !disabledStudentIds.includes(
              getFormIdField(currentStudent.id, sectionId, assignmentId),
            ),
        )
      : currentSectionAllStudents;
    const currentSectionAvailableStudentsLength =
      currentSectionAvailableStudents.length;

    if (currentSectionFormStudentsLength > 0) {
      if (
        currentSectionFormStudentsLength < currentSectionAvailableStudentsLength
      ) {
        sectionName += ` (${currentSectionFormStudentsLength} Student${
          currentSectionFormStudentsLength > 1 ? 's' : ''
        })`;
      } else if (
        currentSectionFormStudentsLength !== currentSectionAllStudentsLength
      ) {
        sectionName += ` (Everyone Else)`;
      }
    }
  }

  return sectionName;
};

export default getSectionName;
